import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from "@mui/material";

export const EditCityDialog = ({
  open,
  onClose,
  saving,
  onSave,
  city,
  errors = {},
}) => {
  const [form, setForm] = useState({ name: "", code: "" });

  useEffect(() => {
    if (open && city) {
      setForm({ name: city.name || "", code: city.code || "" });
    }
  }, [open, city]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = () => {
    onSave(form);
  };

  return (
    <Dialog
      open={open}
      onClose={!saving ? onClose : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit City</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="City Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.name}
              helperText={errors.name?.[0]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="City Code (Unique)"
              name="code"
              value={form.code}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.code}
              helperText={errors.code?.[0]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button onClick={submit} variant="contained" disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
